import OrditAuthenticatedLayout from '@/components/layout/OrditAuthenticatedLayout.vue'
import OrditLayout from '@/components/layout/OrditLayout.vue'
import Vue from 'vue'

Vue.component('ordit-authenticated-layout', OrditAuthenticatedLayout)
Vue.component('ordit-layout', OrditLayout)
